import { GetServerSidePropsContext } from "next";
import { useRouter } from "next/router";

import StackLayout from "@domains/common/views/layouts/StackLayout/StackLayout";
import SignUpComponent from "@domains/auth/views/signup/SignUpComponent";
import { NAVIGATION_ROUTE } from "@domains/common/constants/navigationRoute";
import { loadLocaleProps } from "@logics/utils/i18n";
import GeneralHead from "@logics/tags/GeneralHead";
import { useGuardWebView } from "@logics/hooks/useGuardWebView";

const Signup = () => {
  const { back, push } = useRouter();

  const handleBack = () => {
    if (window.history.length > 1) {
      back();
    } else {
      push(NAVIGATION_ROUTE.EVENT_LIST.HREF);
    }
  };

  useGuardWebView();

  return (
    <>
      <GeneralHead page={{ title: "Enkoplay: Signup" }} />

      <StackLayout
        navbar={{
          iconType: "CHEVRON_LEFT",
          onClickIcon: handleBack,
          title: "Sign up",
        }}
      >
        <SignUpComponent />
      </StackLayout>
    </>
  );
};

export default Signup;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  return {
    props: {
      ...(await loadLocaleProps(context)),
    },
  };
}
